import { render, staticRenderFns } from "./ShipmentByDepartment.vue?vue&type=template&id=066a23b4&scoped=true&"
import script from "./ShipmentByDepartment.vue?vue&type=script&lang=ts&"
export * from "./ShipmentByDepartment.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentByDepartment.vue?vue&type=style&index=0&id=066a23b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a23b4",
  null
  
)

export default component.exports